<template>
    <span v-if="type === 'radio'" class="mr-2 min-w-6 w-6 h-6 bg-white rounded-[40px] border border-anthrazit-60 justify-center items-center inline-flex">
        <span :class="[checked ? 'w-4 h-4 bg-black/95 rounded-[40px]':'']" />
    </span>
    <span v-if="type === 'checkbox'"  class="mr-2 min-w-6 w-6 h-6 bg-white rounded border border-anthrazit-60 justify-start items-start block">
        <SvgIcon :class="[checked ? '':'hidden']" name="checkbox-selected" />
    </span>
    <label :class="['text-left',checked ? 'cursor-pointer text-black/95':'cursor-pointer text-anthrazit-90 hover:text-black/95']">{{ label }}</label>
</template>

<script>
import SvgIcon from "@components/SvgIcon.vue"

export default {
    name: "InputElement",
    components: {
        SvgIcon
    },
    props: {
        checked: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: "checkbox"
        },
        label: {
            type: String,
            default: ""
        },
    }
}
</script>
